import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

class RuntimeWithinValidityValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    constructor(private moment: moment.MomentStatic) {}

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpRuntimeWithinValidityValidator'] = (
            modelValue: DateInterval
        ): boolean => {
            if (
                !modelValue ||
                !modelValue.start ||
                !modelValue.end ||
                attrs.compareRuntime == null
            ) {
                return true;
            }

            const checkRuntime: DateInterval = scope.$eval(
                attrs.compareRuntime
            );
            const modelStart: moment.Moment = this.moment(modelValue.start);
            const modelEnd: moment.Moment = this.moment(modelValue.end);

            if (checkRuntime != null) {
                const runtimeStart: moment.Moment = this.moment(
                    checkRuntime.start
                );
                const runtimeEnd: moment.Moment = this.moment(checkRuntime.end);
                if (
                    !runtimeStart.isBetween(modelStart, modelEnd) ||
                    !runtimeEnd.isBetween(modelStart, modelEnd)
                ) {
                    return false;
                }
            }
            return true;
        };

        scope.$watch(
            () => scope.$eval(attrs.compareRuntime),
            () => ngModelCtrl.$validate(),
            true
        );
    };
}

RuntimeWithinValidityValidator.$inject = ['moment'];

angular
    .module('app')
    .directive(
        'pkpRuntimeWithinValidityValidator',
        (moment) => new RuntimeWithinValidityValidator(moment)
    );
